import React, {
	useState, useRef, useContext, useEffect
} from 'react';
import classNames from 'classnames';
import AccordionContext from './AccordionContext';

const ns = `accordion-panel`;

const AccordionPanel = ({
	className,
	uid,
	render,
	children,
	initialContentHeight = '0px',
	onHeightUpdated,
}) => {
	const {isExpanded} = useContext(AccordionContext);

	const [expanded, setExpanded] = useState(false);
	const [contentHeight, setContentHeight] = useState(initialContentHeight);

	const expandPanel = useRef(null);

	useEffect(() => {
		if (isExpanded(uid)) {
			setExpanded(true);
			setContentHeight(`${ expandPanel.current.scrollHeight }px`);
			onHeightUpdated?.();
		} else {
			setExpanded(false);
			setContentHeight(initialContentHeight);
		}
	}, [isExpanded, uid, initialContentHeight, onHeightUpdated]);

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ className }`]: !!className,
	});

	return (
		<div className={rootClassnames}>
			<div
				className={`${ ns }__content`}
				style={{maxHeight: `${ contentHeight }`}}
				id={uid}
				ref={expandPanel}
			>
				<div className={`${ ns }__content-body`}>
					{
						(typeof render === 'function') && render(expanded)
					}
					{
						!render && (typeof children === 'function' ? children({expandPanel}) : children)
					}
				</div>
			</div>
		</div>
	);
};

export default AccordionPanel;
